// extracted by mini-css-extract-plugin
module.exports = {"actions":"CategoryForm_actions__2tbkY"};